exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{\n    padding:15px;\n    padding-right:0px;\n    padding-left:0px;\n    font-family:Arial;\n    color:white;\n    background-color: rgba(0,0,0,0.6);\n    position:absolute;\n    left:0px;\n    top:700px;\n    width:100%;\n    /* border-radius:6px; */\n    cursor:default;\n}\n\n.group{\n    margin-bottom: 3px;\n    margin-top: 3px;\n    font-size:10pt;\n}\n\n.property{\n    margin-left:15px;\n    height:24px;\n    line-height:24px;\n    font-size:9pt;\n}\n\n/* .title{\n    width:100%;\n    text-align: center;\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/property-selector/property-selector.component.css
// module id = ../../../../../src/app/components/property-selector/property-selector.component.css
// module chunks = main